import apiClient from "../../config/apiClient";


export const fetchAppointments = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=front-desk/appointments?page=1%26limit=15%26patient_id=${id}%26startDate=%26endDate=`, {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // /front-desk/appointments?page=1&limit=15&patient_id=27501&startDate=&endDate=